import { useEffect } from 'react';
import { generatePath } from 'react-router';

import { Navigate } from '@sorare/routing';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';
import { FOOTBALL_ONBOARDING_CHOOSE_YOUR_LEVEL } from '@sorare/core/src/constants/__generated__/routes';

import { useFootballEvents } from '@sorare/marketplace/src/shared/events/lib';

const ProOnboardingPage = () => {
  const track = useFootballEvents();

  useEffect(() => {
    track('Enter General Tutorial');
  }, [track]);

  return (
    <Navigate
      to={generatePath(FOOTBALL_ONBOARDING_CHOOSE_YOUR_LEVEL, {
        eventType: So5FixtureEvent.CLASSIC.toLowerCase(),
      })}
      replace
      keepSearchParams
    />
  );
};

export default ProOnboardingPage;
